<template>
    <tr @click="$emit('click')">
        <td>{{name}}</td>
        <td>{{appointments}}</td>
        <td>{{sold}}</td>
        <td>{{$n(revenue, 'money')}}</td>
        <td :class="{'is-warning': isWarning}">
            <strong>{{conversionText}}</strong>
        </td>
    </tr>
</template>
<script>
    import Vue from 'vue';
    import {Component, Prop} from 'vue-property-decorator';

    @Component
    export default class SellerRow extends Vue {
        @Prop({type: String, default: 'no-name'})
        name;
        @Prop({type: Number, default: 0})
        appointments;
        @Prop({type: Number, default:0})
        sold;
        @Prop({type: Number, default:0})
        revenue;

        warningThreshold = 0.1;

        get conversion() {
            const start = this.appointments;
            const end = this.sold;
            if (start === 0) {
                return undefined;
            } else {
                return end / start;
            }
        }

        get isWarning() {
            return (this.conversion <= this.warningThreshold);
        }

        get conversionText() {
            const fraction = this.conversion;
            if (fraction !== undefined) {
                return this.$n(fraction, 'percentage_whole');
            } else {
                return '';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/widgets/sellers/SellerRow.vue